/**
 * Copyright Mántum All Rights Reserved.
 */
import Contained from '../components/common/button/contained';
import Text from '../components/common/button/text';

type PropTypes = {
    loading?: boolean;
    negative: string;
    onNegative?: () => void;
    onPositive?: () => void;
    positive: string;
};

export default function Action(props: PropTypes) {
    return (
        <div className='mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:justify-end sm:space-x-6'>
            <div className='mb-4 mt-2 flex items-center gap-2'>
                <Text onClick={props.onNegative} testid='cancel'>
                    {props.negative}
                </Text>
                <Contained
                    onClick={props.onPositive}
                    loading={props.loading}
                    testid='accept'
                >
                    {props.positive}
                </Contained>
            </div>
        </div>
    );
}
